<!-- collapsible title -->
@if (!item().url) {
  <a class="d-flex align-items-center"
     [ngClass]="item().classes"
     (click)="toggleOpen($event)">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>
}

<!-- itemContent template -->
<ng-template #itemContent>
  @if (item().icon) {
    <span [data-feather]="item().icon"></span>
  }
  <span class="menu-title text-truncate"
        [translate]="item().translate">{{ item().title }}</span>
  @if (item().badge) {
    <span class="badge ml-auto mr-1"
          [translate]="item().badge.translate"
          [ngClass]="item().badge.classes">
      {{ item().badge.title }}
    </span>
  }
</ng-template>

<!-- sub-menu item/collapsible -->
<ul class="menu-content">
  @for (child of item().children; track child.id) {
    <!-- item -->
    @if (child.type == 'item') {
      <li core-menu-vertical-item
          [item]="child"
          [ngClass]="{ disabled: child.disabled === true }"
          [routerLinkActive]="!child.openInNewTab ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: child.exactMatch || false }">
        <span [routerLink]="child.openInNewTab ? [] : [child.url]"
              class="d-none"></span>
      </li>
    }
    <!-- collapsible -->
    @if (child.type == 'collapsible') {
      <li core-menu-vertical-collapsible
          [item]="child"
          class="nav-item has-sub"></li>
    }
  }
</ul>
